// @flow strict

import * as React from 'react';

// author: cahuja
// since: Nov 01, 2019

export { default as RobotSafeClientOnly } from './RobotSafeClientOnly';
export { useIsRobotSafe } from './RobotSafeClientOnly';

export { default as MountedClientOnly } from './MountedClientOnly';
export { default as IsMountedClient } from './IsMountedClient';

export const useIsMounted = () => {
  const [isMounted, setIsMounted] = React.useState(false);
  React.useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, [setIsMounted]);
  return isMounted;
};
